import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container } from "react-bootstrap";
import Slider from "../../Components/Slider/Slider";
import {
  searchMulti,
  fetchTrendingMovies,
  fetchPopularTVShows,
} from "../../Api/Moviesapi";
import { ErrorState, LoadingState } from "../../Components/PageState/PageState";

const Search = () => {
  const { query } = useParams();

  const [movieResults, setMovieResults] = useState([]);
  const [tvResults, setTvResults] = useState([]);
  const [noResults, setNoResults] = useState(false);
  const [recommendedMovies, setRecommendedMovies] = useState([]);
  const [recommendedTV, setRecommendedTV] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    const loadSearch = async () => {
      try {
        setLoading(true); setError("");
        const results = await searchMulti(query);

        const movies = results.filter(
          (item) => item.media_type === "movie"
        );
        const tvShows = results.filter(
          (item) => item.media_type === "tv"
        );

        if (!active) return;
        setMovieResults(movies); setTvResults(tvShows);

        if (movies.length === 0 && tvShows.length === 0) {
          setNoResults(true);

          const [recMovies, recTV] = await Promise.all([fetchTrendingMovies(), fetchPopularTVShows()]);

          setRecommendedMovies(recMovies);
          setRecommendedTV(recTV);
        } else {
          setNoResults(false);
        }
      } catch (error) {
        if (active) setError(error.message);
      } finally {
        if (active) setLoading(false);
      }
    };

    loadSearch();
    return () => { active = false; };
  }, [query]);

  if (loading) return <LoadingState label={`Searching for “${query}”…`} />;
  if (error) return <ErrorState message={error} />;

  return (
    <Container
      fluid
      style={{
        margin: 0,
        padding: 0,
        backgroundColor: "#111",
        minHeight: "100vh",
      }}
    >
      {noResults && (
        <h3 className="text-light mb-3 ps-3">
          No results found for "{query}"
        </h3>
      )}

      {movieResults.length > 0 && (
        <Slider
          title={`Movie Results for "${query}"`}
          movies={movieResults}
        />
      )}

      {tvResults.length > 0 && (
        <Slider
          title={`TV Show Results for "${query}"`}
          movies={tvResults}
        />
      )}

      {noResults && (
        <>
          <Slider title="Trending Movies" movies={recommendedMovies} />
          <Slider title="Popular TV Shows" movies={recommendedTV} />
        </>
      )}
    </Container>
  );
};

export default Search;
